import Lottie from "react-lottie";
import React from "react";
import * as robotData from "../../../commons/robot.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: robotData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const AiFeatures = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "min(50vw, 60vh)"
      }}
    >
      {/* Square animation that shrinks to the screen width on phones */}
      <div style={{ width: "100%", maxWidth: 400, aspectRatio: "1 / 1" }}>
        <Lottie options={defaultOptions} height="100%" width="100%" />
      </div>
    </div>
  );
};

export default AiFeatures;
